const faFaceViewfinder = {
  prefix: 'fal',
  iconName: 'face-viewfinder',
  icon: [
    512,
    512,
    [],
    'e2ff',
    'M64 0C28.7 0 0 28.7 0 64l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-17.7 14.3-32 32-32l80 0c8.8 0 16-7.2 16-16S152.8 0 144 0L64 0zM448 0L368 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c17.7 0 32 14.3 32 32l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-35.3-28.7-64-64-64zM0 448c0 35.3 28.7 64 64 64l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0c-17.7 0-32-14.3-32-32l0-80c0-8.8-7.2-16-16-16S0 359.2 0 368l0 80zm448 64c35.3 0 64-28.7 64-64l0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80c0 17.7-14.3 32-32 32l-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0zM232 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zM214.4 288c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c13.8 23.9 39.7 40 69.3 40s55.5-16.1 69.3-40c4.4-7.7 1.8-17.4-5.8-21.9s-17.4-1.8-21.9 5.8c-8.3 14.4-23.8 24-41.6 24s-33.3-9.6-41.6-24z',
  ],
};
export default faFaceViewfinder;
